import React, { useState, useEffect } from 'react';

const Search = ({ onSearch }) => {
    const [searchTerm, setSearchTerm] = useState('');
    const [isListening, setIsListening] = useState(false);
    const [voiceSearchTriggered, setVoiceSearchTriggered] = useState(false);
    let recognition;

    const handleInputChange = (e) => {
        setSearchTerm(e.target.value);
        onSearch(e.target.value);
    };

    const handleKeyPress = (e) => {
        if (e.key === 'Enter') {
            handleSearch();
        }
    };

    const handleSearch = () => {
        onSearch(searchTerm);
    };

    const handleVoiceInput = () => {
        if (isListening) {
            stopListening();
        } else {
            startListening();
        }
    };

    const startListening = () => {
        setIsListening(true);

        if ('webkitSpeechRecognition' in window) {
            recognition = new window.webkitSpeechRecognition();
            recognition.lang = 'en-US';

            recognition.onstart = () => {
                console.log('Voice recognition started');
            };

            recognition.onresult = (event) => {
                let transcript = event.results[0][0].transcript.trim();
                if (transcript.charAt(transcript.length - 1) === '.') {
                    transcript = transcript.slice(0, -1); 
                }
                setSearchTerm(transcript);
                setVoiceSearchTriggered(true); 
                console.log('Voice input:', transcript);
                stopListening();
            };

            recognition.onend = () => {
                setIsListening(false);
            };

            recognition.onerror = (event) => {
                console.error('Speech recognition error:', event.error);
                stopListening();
            };

            recognition.start();
        } else {
            console.error('Speech recognition not supported');
        }
    };

    const stopListening = () => {
        setIsListening(false);
        if (recognition) {
            recognition.stop();
        }
    };

    useEffect(() => {
        if (voiceSearchTriggered) {
            handleSearch();
            setVoiceSearchTriggered(false); 
        }
    }, [voiceSearchTriggered]);

    useEffect(() => {
        return () => {
            stopListening();
        };
    }, []);

    return (
        <div className="search-container">
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width="40"
                height="49"
                viewBox="0 0 40 49"
                fill="none"
            >
                <path d="M18.8023 37.3044C25.5039 37.3044 30.9367 30.7532 30.9367 22.6718C30.9367 14.5905 25.5039 8.03925 18.8023 8.03925C12.1007 8.03925 6.66797 14.5905 6.66797 22.6718C6.66797 30.7532 12.1007 37.3044 18.8023 37.3044Z" stroke="black" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M27.3906 33.0254L34.4869 41.5827" stroke="black" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
            <input
                type="text"
                value={searchTerm}
                onChange={handleInputChange}
                onKeyPress={handleKeyPress}
                className="search-input"
                placeholder="What are you searching for?"
            />
            <svg
                onClick={handleVoiceInput}
                xmlns="http://www.w3.org/2000/svg"
                width="67"
                height="49"
                viewBox="0 0 67 49"
                fill="none"
            >
                <path d="M33.118 30.4211C37.6711 30.4211 41.3191 27.7764 41.3191 24.5L41.3465 12.6579C41.3465 9.38161 37.6711 6.73688 33.118 6.73688C28.5648 6.73688 24.8894 9.38161 24.8894 12.6579V24.5C24.8894 27.7764 28.5648 30.4211 33.118 30.4211ZM47.6551 24.5C47.6551 30.4211 40.6882 34.5658 33.118 34.5658C25.5477 34.5658 18.5808 30.4211 18.5808 24.5H13.918C13.918 31.25 21.3785 36.7961 30.3751 37.7632V44.2369H35.8608V37.7632C44.8574 36.8158 52.318 31.25 52.318 24.5H47.6551Z" fill="#808080"/>
            </svg>
        </div>
    );
};

export default Search;
